import { useStore } from 'stook'

interface IAppLocationTypes {
  adCode: string,
  address: string,
  cityCode: string;
  coords: {
    latitude: number;
    longitude: number;
  }
}

export default function useAppLocationData() {
  const [appLocationData, setAppLocationData] = useStore<IAppLocationTypes | null>('appLocationData', null);

  return {
    appLocationData,
    setAppLocationData,
  }
}
